module.exports = __webpack_public_path__ + "media/images/wfc/city-1-efa9943035512deeb06a135cf486cb6e.jpg";